import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { pick } from 'lodash-es';

import { DotCmsState } from './dot-cms-store';
import { DotCmsConfigurableContentsEffects } from './dotcms-configurable-contents/dotcms-configurable-contents.effects';
import { dotCmsConfigurableContentsReducer } from './dotcms-configurable-contents/dotcms-configurable-contents.reducer';
import { DotCmsConfigurationEffects } from './dotcms-configuration/dotcms-configuration.effects';
import { dotCmsConfigurationReducer } from './dotcms-configuration/dotcms-configuration.reducer';
import { dotCmsContainerReducer } from './dotcms-container/dotcms-container.reducer';
import { DotCmsContentletEffects } from './dotcms-contentlets/dotcms-contentlets.effects';
import { dotCmsContentletsReducer } from './dotcms-contentlets/dotcms-contentlets.reducer';
import { DotCmsNavigationEffects } from './dotcms-navigation/dotcms-navigation.effects';
import { dotCmsNavigationReducer } from './dotcms-navigation/dotcms-navigation.reducer';
import { DotCmsPagesEffects } from './dotcms-pages/dotcms-pages.effects';
import { dotCmsPagesReducer } from './dotcms-pages/dotcms-pages.reducer';
import { DotcmsSeoEffects } from './dotcms-seo/dotcms-seo.effects';

const dotCmsReducers: ActionReducerMap<DotCmsState> = {
  configuration: dotCmsConfigurationReducer,
  pages: dotCmsPagesReducer,
  contentlets: dotCmsContentletsReducer,
  navigation: dotCmsNavigationReducer,
  containers: dotCmsContainerReducer,
  configurableContents: dotCmsConfigurableContentsReducer,
};

const dotCmsEffects = [
  DotCmsConfigurationEffects,
  DotCmsPagesEffects,
  DotCmsContentletEffects,
  DotCmsNavigationEffects,
  DotCmsConfigurableContentsEffects,
  DotcmsSeoEffects,
];

@NgModule({
  imports: [EffectsModule.forFeature(dotCmsEffects), StoreModule.forFeature('dotCms', dotCmsReducers)],
})
export class DotCmsStoreModule {
  static forTesting(...reducers: (keyof ActionReducerMap<DotCmsState>)[]) {
    return StoreModule.forFeature('dotCms', pick(dotCmsReducers, reducers));
  }
}
